import axios from 'axios';
import { MEDIAHOLD_INGEST_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import {
  MediaholdIngestHistoryDetail,
  MediaholdIngestHistoryItem,
  MediaholdStats,
} from '../type/mediaholdIngestType';

class MediaholdIngestService extends ApiService<MediaholdIngestHistoryItem> {
  constructor() {
    super(MEDIAHOLD_INGEST_API_PATH);
  }

  // 목록 조회
  public async fetch(
    queryParams?: URLSearchParams,
  ): Promise<FetchResult<MediaholdIngestHistoryItem>> {
    return super.fetch(queryParams);
  }

  // 상세 조회
  public async fetchOne(id: number): Promise<MediaholdIngestHistoryDetail> {
    return super.fetchById(id);
  }

  // 통계 조회
  public async fetchStats(queryParams?: URLSearchParams): Promise<MediaholdStats> {
    const response = await axios.get(this.constructUrl(undefined, 'stats'), {
      params: queryParams,
    });
    return response.data;
  }

  // 재처리 가능한 메시지 목록 조회
  public async fetchRetryable(
    queryParams?: URLSearchParams,
  ): Promise<FetchResult<MediaholdIngestHistoryItem>> {
    const response = await axios.get(this.constructUrl(undefined, 'retryable'), {
      params: queryParams,
    });
    return response.data;
  }
}

export const mediaholdIngestService = new MediaholdIngestService();

